import type { ReactNode } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { usePermissions } from 'react-admin';

import { hasSpeechCalibrationPermission } from './speechCalibrationConstants';

export function SpeechCalibrationAccess({
    requiredTags,
    children,
}: {
    requiredTags: string[];
    children: ReactNode;
}) {
    const { permissions, isPending } = usePermissions();

    if (isPending) {
        return (
            <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 240 }}>
                <CircularProgress aria-label="Checking speech calibration access" />
            </Box>
        );
    }

    if (!hasSpeechCalibrationPermission(permissions, requiredTags)) {
        return (
            <Alert severity="error" sx={{ m: 2 }}>
                Your admin account does not have permission to use this speech calibration screen.
            </Alert>
        );
    }

    return children;
}
